import React from 'react';
import { Circle, Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const Cart: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path d='M2 2C1.44772 2 1 2.44772 1 3C1 3.55228 1.44772 4 2 4V2ZM5.09677 3L6.07763 2.80529C5.98471 2.3372 5.57399 2 5.09677 2V3ZM7.67742 16L6.69656 16.1947C6.78948 16.6628 7.2002 17 7.67742 17V16ZM19 17C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15V17ZM2 4H5.09677V2H2V4ZM4.11591 3.19471L6.69656 16.1947L8.65828 15.8053L6.07763 2.80529L4.11591 3.19471ZM7.67742 17H19V15H7.67742V17Z' />
    <Path d='M5.25667 5.20786C5.12448 4.5858 5.59888 4 6.23483 4H20.7652C21.4011 4 21.8755 4.5858 21.7433 5.20786L20.0433 13.2079C19.9452 13.6697 19.5373 14 19.0652 14H7.93483C7.46265 14 7.05482 13.6697 6.95667 13.2079L5.25667 5.20786Z' />
    <Circle cx='8' cy='19' r='2' />
    <Circle cx='18' cy='19' r='2' />
  </SVG>
);
